import {
    Button,
    Card,
    Col,
    Form,
    InputNumber,
    notification,
    Row,
} from 'antd';
import { useEffect, useState } from 'react';
import { IBusiness } from '../../../types/bussiness';
import { getExpressSettings, updateExpressSettings } from '../../../api/business-settings';

interface ExpressSettingsProps {
    business: IBusiness;
}

interface IExpressSettings {
    maxDeliveryTime?: number;
    maxPreparationTime?: number;
    userBusinessID: string;
}

const ExpressSettings = ({ business }: ExpressSettingsProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [settings, setSettings] = useState<IExpressSettings | null>(null);
    const [form] = Form.useForm();

    const fetchSettings = async () => {
        setLoading(true);
        getExpressSettings(business?._id)
            .then(({ data }) => {
                setSettings(data.data);
                form.setFieldsValue(data.data);
            })
            .catch((err) => {
                const description = err?.response?.data?.message || 'Failed to fetch settings';
                notification.error({
                    message: 'Error',
                    description,
                });
            })
            .finally(() => setLoading(false));
    };

    const updateSettings = (settings: any) => {
        setLoading(true);
        updateExpressSettings(business?._id, settings)
            .then(({ data }) => {
                setSettings(data.data);
                notification.success({
                    message: 'Settings updated successfully',
                });
            })
            .catch((err) => {
                const description = err?.response?.data?.message || 'Failed to update settings';
                notification.error({
                    message: 'Error',
                    description,
                });
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!business?._id) return;
        fetchSettings();
    }, [business?._id]);

    return (
        <Card
            title="Express Settings"
            extra={[
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    onClick={() => form.submit()}
                >
                    Save
                </Button>,
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={updateSettings}
                initialValues={settings || {
                    maxDeliveryTime: 0,
                    maxPreparationTime: 0,
                }}
            >
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item
                            label="Max Delivery Time (minutes)"
                            name="maxDeliveryTime"
                            rules={[{ required: true, message: 'Max Delivery Time is required' }]}
                        >
                            <InputNumber
                                min={1}
                                max={240}
                                addonAfter="minutes"
                                disabled={loading}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Max Preparation Time (minutes)"
                            name="maxPreparationTime"
                            rules={[{ required: true, message: 'Max Preparation Time is required' }]}
                        >
                            <InputNumber
                                min={1}
                                max={60}
                                addonAfter="minutes"
                                disabled={loading}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};

export default ExpressSettings;
